/* src/app/shared/modals/array-list-modal/array-list-modal.component.scss */
.array-list-modal .modal-content {
  overflow-y: auto;
}
.array-list-modal .array-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.array-list-modal .array-row {
  padding: 8px 0;
  border-bottom: 1px solid var(--secondary-subtle-hover);
  font-size: 14px;
  line-height: 20px;
  color: var(--secondary-subtle-contrast);
}
/*# sourceMappingURL=array-list-modal.component.css.map */
